import styles from './pageWrapper.module.scss';

const PageWrapper = ({ children, className }) => {
  return (
    <div className={styles.wrapper + ' ' + (className || '')}>{children}</div>
  );
};

export default PageWrapper;
